export abstract class ICryptography {
  public abstract myPublicKey(): Promise<string>;
  public abstract importKey(theirPublicKey: string): Promise<CryptoKey>;
  public abstract encrypt(data: any, theirPublicKey: CryptoKey): Promise<string>;
  public abstract decrypt(data: string): Promise<any>;
  public abstract hashOf(obj: any): Promise<string>;
}
